import { Grid } from '@mui/material';
import { FC } from 'react';
import { Link, Outlet, useLocation } from 'react-router-dom';
import { Typography } from 'src/components';

const NonAuthLayout: FC = () => {
  const location = useLocation();

  return (
    <>
      <nav
        aria-label="Horizontal School Form Navigation"
        className="cb-menu-list cb-menu-list-horizontal position-sticky cb-border-bottom cb-box-shadow-bottom cb-white-bg display-flex justify-content-xs-between align-items-xs-center"
        style={{ height: 56, paddingLeft: 16, top: 0, zIndex: 100 }}>
        {location.pathname !== '/' ? (
          <Typography variant="h3" style={{ fontWeight: 'bold' }}>
            Code Request Portal
          </Typography>
        ) : (
          <div />
        )}
      </nav>
      <Grid container justifyContent="stretch">
        <Grid item xs={12}>
          <Outlet />
        </Grid>
      </Grid>
    </>
  );
};

export default NonAuthLayout;
